import { getKblNoticeDetail } from "api/kbl/kbl";
import { format } from "date-fns";
import React from "react";
import { useRouteMatch } from "react-router-dom";

const SonicBoomArticleDetail = () => {
  const [data, setData] = React.useState();
  const matchSeq = useRouteMatch("/kbl/sonicboom/notice/:seq");
  console.log("DetailMatchSeq", matchSeq);

  React.useEffect(() => {
    getKblNoticeDetail({ seq: matchSeq.params.seq })
      .then((response) => {
        setData(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching KBL notice:", error);
      });
  }, [matchSeq.params.seq]);

  const article = data && {
    ...data,
    title: data.artcTitle,
    content: data.artcContent,
    nextSeq: data.artcNextSeq,
    prevSeq: data.artcPrevSeq,
    registerAt: new Date(data.regDttm),
  };

  return (
    <>
      <div className="detail_wrap">
        <article className="article">
          <div className="article_tit_wrap">
            <dl className="article_tit">
              <dt>
                <h4>{article && article.title}</h4>
              </dt>
              <dd>
                <ul className="tit_info">
                  <li>
                    <span className="date">
                      {article &&
                        article.registerAt instanceof Date &&
                        !isNaN(article.registerAt) &&
                        format(article.registerAt, "yyyy.MM.dd")}
                    </span>
                    <span className="icon_calendar"></span>
                  </li>
                  {article && article.viewCnt ? (
                    <li className="last">
                      <span className="count">{article.viewCnt}</span>
                      <span className="icon_time"></span>
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
              </dd>
            </dl>
          </div>
          <div className="article_content_wrap">
            <div className="article_content">
              {article && article.videoLink ? (
                <>
                  <div className="video_wrap">
                    <div className="video">
                      <iframe
                        src={article && article.videoLink}
                        // width='640'
                        // height='360'
                        frameBorder="0"
                        allow="autoplay; fullscreen"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              <div dangerouslySetInnerHTML={{ __html: article && article.content }}></div>
            </div>
          </div>
        </article>
        <div className="share_btn_wrap">
          <ul className="clearfix">
            {/* <li>
              <Link to='' className='btn_share kakaotalk' onClick={kakaoShare} />
            </li>
            <li>
              <Link to='' onClick={() => {
                window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, 'newwindow', 'width=700,height=700')
              }
              } className='btn_share facebook' target='_blank' />
            </li > */}
            {/* <li>
              <a href='' className='btn_share normal'></a>
            </li> */}
          </ul>
        </div>
      </div>
    </>
  );
};

export default SonicBoomArticleDetail;
